import { render, staticRenderFns } from "./tos-options.vue?vue&type=template&id=b0d0e3e0&scoped=true"
import script from "./tos-options.vue?vue&type=script&lang=js"
export * from "./tos-options.vue?vue&type=script&lang=js"
import style0 from "./tos-options.vue?vue&type=style&index=0&id=b0d0e3e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d0e3e0",
  null
  
)

export default component.exports